<template lang="pug">
  .pho-autocomplete
    PhoValidationProvider(:rules="rules" :name="name")
      v-autocomplete.nowrap(
        v-model="lazyValue"
        v-on="$listeners"
        spellcheck="false"
        :attach="attach"
        :clearable="clearable"
        :dense="dense"
        :items="lazyItem"
        :item-value="itemValue"
        :item-text="itemText"
        :multiple="multiple"
        :label="label"
        :readonly="readonly"
        :disabled="disabled"
        :outlined="outlined"
        :prepend-icon="prependIcon"
        :return-object="returnObject"
        :search-input.sync="search"
        @change="onValueChanged"
      )
</template>

<script>
import { useModelBinding } from '@/helpers/misc/binding';
import { useSelectedSorter } from '@/helpers/misc';
import { filterSelectedValues } from '@/helpers/content';
import {
  onMounted, ref, watch,
} from 'vue';
import PhoValidationProvider from './PhoValidationProvider.vue';

export default {
  name: 'PhoSelect',
  components: {
    PhoValidationProvider,
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object],
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
    attach: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    prependIcon: {
      type: String,
    },
    itemText: {
      type: [String, Array],
      default: 'text',
    },
    itemValue: {
      type: [String, Array],
      default: 'value',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const { lazyValue, updateValue } = useModelBinding(emit, props);
    const items = ref([]);
    const search = ref('');
    const getItems = () => {
      items.value = props.items || [];
    };

    onMounted(() => {
      getItems();
    });

    watch(() => props.items, () => getItems());

    const [lazyItem] = useSelectedSorter(items, lazyValue, filterSelectedValues, 'id');

    const onValueChanged = value => {
      if (!value || value.length <= 0) {
        updateValue(null);

        return;
      }

      updateValue(value);
      search.value = '';
    };

    return {
      lazyValue,
      lazyItem,
      search,
      onValueChanged,
    };
  },
};
</script>
